export const NotificationQueryKeys = {
  all: ['package'] as const,
  lists: () => [...NotificationQueryKeys.all, 'list'] as const,
  list: (filters: object) =>
    [...NotificationQueryKeys.lists(), filters] as const,
  details: () => [...NotificationQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...NotificationQueryKeys.details(), id] as const,
};
